module.exports = __webpack_public_path__ + "static/media/sk.f430be3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sk.svg
// module id = 247
// module chunks = 0